@if (data) {
<mat-form-field appearance="outline">
  <input
    (ngModelChange)="fetchData($event)"
    [(ngModel)]="userName"
    [matAutocomplete]="auto"
    matInput
    placeholder="Search to add more coworkers..."
    type="text"
  />
  @if (loading) {
  <mat-progress-bar class="search-loading" mode="query"></mat-progress-bar>
  }
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="updateSelection($event.option)">
    @for (option of optionsList; track option) {
    <mat-option [value]="option">
      <div class="invite-user">
        <mds-avatar
          [altText]="option.type == 'user' ? option.firstname + option.lastname : option.name"
          [firstName]="option.type == 'user' ? option.firstname : option.name"
          [imageSrc]="option.type == 'user' ? option.avatar : '/assets/images/icon-tiny-team.svg'"
          [lastName]="option?.lastname"
        ></mds-avatar>
        <div class="invite-name">
          @if (option.type == 'user') {
          <span>{{ option.firstname }} {{ option.lastname }}</span>
          <span>{{ option.company }}</span>
          } @if (option.type == 'team') {
          <span>{{ option.name }}</span>
          <span>Team</span>
          }
        </div>
      </div>
    </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
}
